import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["memberType", "eligibilityField", "olehStatus", "olehStatusDetails"]
  static values = { adultTypes: Array, teudatStatuses: Array }

  connect() {
    this.toggle()
    this.toggleOlehDetails()
  }

  toggle() {
    if (!this.hasEligibilityFieldTarget || !this.hasMemberTypeTarget) return

    const type = this.memberTypeTarget.value
    const isAdult = this.adultTypesValue.includes(type)
    this.eligibilityFieldTarget.classList.toggle("hidden", !isAdult)
  }

  toggleOlehDetails() {
    if (!this.hasOlehStatusDetailsTarget || !this.hasOlehStatusTarget) return

    const status = this.olehStatusTarget.value
    const show = this.teudatStatusesValue.includes(status)
    this.olehStatusDetailsTarget.classList.toggle("hidden", !show)

    const teudatInput = this.olehStatusDetailsTarget.querySelector('input[name*="[teudat_zehut]"]')
    const passportSelect = this.olehStatusDetailsTarget.querySelector('select[name*="[valid_israeli_passport]"]')
    if (teudatInput) teudatInput.required = show
    if (passportSelect) passportSelect.required = show
  }
}
